(() => {
  if (window.acS10SaleTabInitialized) return;
  window.acS10SaleTabInitialized = true;
  const selector = '[class*="kl-teaser-"]';
  let frame = 0;
  let nativeTrigger = null;
  let nativeFormId = null;
  const dismissed = new Set();

  function keyFor(tab) {
    return `ac-s10-sale-tab:${tab.dataset.country}:${tab.dataset.currency}:${tab.dataset.saving}`;
  }
  function isDismissed(tab) {
    const key = keyFor(tab);
    try { return dismissed.has(key) || sessionStorage.getItem(key) === 'closed'; }
    catch { return dismissed.has(key); }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function update() {
    frame = 0;
    const tab = document.querySelector('[data-ac-s10-sale-tab]');
    if (!tab) return;
    const currency = (tab.dataset.currency || 'USD').toUpperCase();
    const amount = { AUD: 'A$200', CAD: 'C$200', EUR: '€200', GBP: '£200', USD: '$200' }[currency] || `${currency} 200`;
    const offerTitle = `Get ${amount} OFF`;
    const offerButton = tab.querySelector('[data-ac-s10-sale-open]');
    const offerLabel = offerButton?.querySelector('span');
    if (offerLabel && offerLabel.textContent !== offerTitle) offerLabel.textContent = offerTitle;
    if (offerButton && offerButton.getAttribute('aria-label') !== offerTitle) offerButton.setAttribute('aria-label', offerTitle);
    const footer = document.getElementById('ac-home-footer');
    const timer = document.querySelector('ac-sale-countdown[end-at]');
    const endAt = Date.parse(timer?.getAttribute('end-at') || '');
    const active = !Number.isFinite(endAt) || Date.now() < endAt;
    const nativeTeaser = [...document.querySelectorAll(selector)].find(el => {
      const style = getComputedStyle(el);
      return style.display !== 'none' && el.getBoundingClientRect().height > 0
        && el.querySelector('[role="button"],button');
    });
    nativeTrigger = nativeTeaser?.querySelector('[role="button"],button') || null;
    if (nativeTeaser) nativeTeaser.setAttribute('data-ac-s10-native-teaser', '');
    const ready = active && !!nativeTrigger;
    document.body.toggleAttribute('data-ac-s10-sale-tab-ready', ready);
    const visible = ready && !isDismissed(tab);
    if (tab.hidden === visible) tab.hidden = !visible;
    footer?.toggleAttribute('data-ac-s10-side-tab', visible);

    nativeFormId = nativeTeaser?.className.match(/\bkl-teaser-([a-zA-Z0-9]+)\b/)?.[1] || nativeFormId;
    let offerOpen = false;
    if (nativeFormId) {
      const form = document.querySelector(`[data-testid="klaviyo-form-${nativeFormId}"]`);
      const dialog = form?.closest('[role="dialog"]');
      if (dialog) {
        const style = getComputedStyle(dialog);
        offerOpen = style.display !== 'none' && style.visibility !== 'hidden' && dialog.getBoundingClientRect().height > 0;
      }
      const heading = form?.querySelector('h1,h2,h3');
      if (active && heading && /Acemate\s+S10/i.test(heading.textContent)) {
        const copy = `${offerTitle} Acemate S10. Join our email list for news and offers.`;
        if (heading.getAttribute('data-ac-s10-offer-copy') !== copy) {
          heading.setAttribute('data-ac-s10-offer-copy', copy);
          heading.setAttribute('aria-label', copy);
          heading.setAttribute('translate', 'no');
          heading.setAttribute('data-transcy-ignore', 'true');
        }
      }
    }
    document.body.toggleAttribute('data-ac-s10-offer-open', offerOpen);
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-ac-s10-sale-tab]');
    if (!tab) return;
    if (event.target.closest('[data-ac-s10-sale-dismiss]')) {
      const key = keyFor(tab);
      dismissed.add(key);
      try { sessionStorage.setItem(key, 'closed'); } catch {}
      update();
    } else if (event.target.closest('[data-ac-s10-sale-open]')) {
      if (nativeFormId) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', nativeFormId]);
      }
      schedule();
    }
  });

  new MutationObserver(records => {
    const relevant = '[class*="kl-teaser-"], [data-testid^="klaviyo-form-"], [data-ac-s10-sale-tab], ac-sale-countdown';
    if (records.some(record => record.type === 'childList'
      ? [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant)))
        || record.target.closest?.('[data-testid^="klaviyo-form-"]')
      : record.target !== document.body && (record.target.matches(selector)
        || record.target.closest('[data-testid^="klaviyo-form-"]')
        || record.target.querySelector('[data-testid^="klaviyo-form-"]')))) schedule();
  }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']});
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  setInterval(schedule, 60000);
  update();
})();
